"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessageStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.ChatMessageStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    text: (0, superstruct_1.string)(),
    sender: (0, superstruct_1.enums)(['counter', 'visitor']),
    senderId: (0, superstruct_1.string)(),
    senderName: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    createdAt: utils_1.TimestampStruct,
    readByVisitor: (0, superstruct_1.defaulted)((0, superstruct_1.optional)((0, superstruct_1.boolean)()), false),
});
exports.ChatMessageStruct.type = 'ChatMessage';
//# sourceMappingURL=chatMessage.js.map